export const tileInfo = [
    "Empty tile",
    "The left edge of a platform",
    "The middle of a platform",
    "The right edge of a platform",
    "A single brick",
    "A decorative brick",
    "Tileable floor",
    "The left edge of a platform",
    "The middle of a platform",
    "The middle of a platform",
    "The right edge of a platform",
    "A solid on top platform",
    "A single brick",
    "The left edge of a block",
    "The right edge of a block",
    "The left edge of a block",
    "The right edge of a block",
    "The left edge of a block",
    "The right edge of a block",
    "The top edge of a block",
    "The left edge of a block",
    "The right edge of a block",
    "A solid on top platform",
    "The left edge of a block",
    "The right edge of a block",
    "The left edge of a block",
    "The right edge of a block",
    "A solid on top platform",
    "The left edge of a platform",
    "The middle of a platform",
    "The right edge of a platform",
    "The left edge of a platform",
    "The middle of a platform",
    "The middle of a platform",
    "The right edge of a platform",
    "????",
    "????",
    "????",
    "????",
    "The bottom edge of a block",
    "The left edge of a platform",
    "The middle of a platform",
    "The right edge of a platform",
    "The left edge of a platform",
    "The middle of a platform",
    "The right edge of a platform",
    "The left edge of a platform",
    "The middle of a platform",
    "The right edge of a platform",
    "The left edge of a platform",
    "The middle of a platform",
    "The right edge of a platform",
    "A dissolving platform",
    "A dissolving platform",
    "A dissolving platform",
    "A dissolving platform",
    "A dissolving platform",
    "A dissolving platform",
    "????",
    "????",
    "Banana item",
    "Grape item",
    "Cherry item",
    "Watermelon item",
    "Peach item",
    "????",
    "????"
];